import { minutesToMilliseconds, secondsToMilliseconds } from "date-fns";

const JWT_REFRESH_MARGIN = minutesToMilliseconds(1);
const JWT_MAX_SHORT_REFRESH_WAIT = secondsToMilliseconds(30);

export const calculateTokenRefreshDelay = (expiryIn: number): number => {
   if (!Number.isFinite(expiryIn) || expiryIn <= 0) {
      return 0;
   }

   const refreshBeforeExpiry = expiryIn - JWT_REFRESH_MARGIN;
   if (refreshBeforeExpiry > 0) {
      return refreshBeforeExpiry;
   }

   return Math.min(JWT_MAX_SHORT_REFRESH_WAIT, Math.floor(expiryIn / 2));
};
